import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import {
  resetOrderType,
  resetGroupOrder,
  resetCheckout,
  useAppDispatch,
} from '@open-tender/cloud'
import { ButtonLink, Button } from 'components'
import { closeModal } from '@open-tender/cloud'
import { ModalContent, ModalView } from '..'

const GroupOrderLeaveFooter = styled.div`
  justify-content: center !important;
  font-size: ${(props) => props.theme.fonts.sizes.small};
`

const GroupOrderLeave = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const leave = () => {
    dispatch(resetOrderType())
    dispatch(resetGroupOrder())
    dispatch(resetCheckout())
    navigate(`/guest`)
  }

  const cancel = () => {
    dispatch(closeModal())
  }

  return (
    <ModalView>
      <ModalContent
        title="Leave group order?"
        subtitle={
          <p>
            If you proceed, you'll need to rejoin thie group order and start
            over from scratch if you want to participate
          </p>
        }
        style={{ textAlign: 'center' }}
        footer={
          <GroupOrderLeaveFooter>
            <ButtonLink onClick={cancel}>
              Nevermind, I'll keep ordering
            </ButtonLink>
          </GroupOrderLeaveFooter>
        }
      >
        <Button onClick={leave}>Leave Group Order</Button>
      </ModalContent>
    </ModalView>
  )
}

export default GroupOrderLeave
